const assetsPath = 'https://cdn.nordnet.fr/components/v2/assets/components';
export default assetsPath;
